import React, { PropsWithChildren, useContext, useEffect, useMemo } from 'react';
import HeaderContext from '../Header/HeaderContext';
import ReactDOM from 'react-dom';
import { useGetActiveProject, useIsSeller, usePageTitle } from '@/utils/hooks';
import PageTitleProjectName from './PageTitleProjectName';

interface PageTitleProps extends PropsWithChildren {
    transparent?: boolean;
}

export const PageTitle: React.FC<PageTitleProps> = ({ children, transparent = false }) => {
    const context = useContext(HeaderContext);
    const isSeller = useIsSeller();
    useEffect(() => {
        context.setTransparent(transparent);
    }, [transparent, context]);

    if (!context.container) {
        return null;
    }

    return ReactDOM.createPortal(
        <>
            <div>{children}</div>
            {isSeller && context.isInProject && <PageTitleProjectName />}
        </>,

        context.container
    );
};

interface SimplePageTitleProps {
    title: string;
    transparent?: boolean;
}

export const SimplePageTitle: React.FC<SimplePageTitleProps> = ({ title, transparent = false }) => {
    const project = useGetActiveProject();
    const context = useContext(HeaderContext);

    const generateDocumentTitle = () => {
        if (context.isInProject && project) {
            return `${title} (${project?.name})`;
        }

        return title;
    };

    usePageTitle(generateDocumentTitle());

    return <PageTitle transparent={transparent}>{title}</PageTitle>;
};
